// Language Management System
export type Language = 'ar' | 'en'

export interface TranslationKeys {
  // Site Info
  siteName: string
  siteDescription: string
  
  // Common
  loading: string
  error: string
  success: string
  cancel: string
  save: string
  saving: string
  delete: string
  edit: string
  create: string
  search: string
  back: string
  next: string
  previous: string
  close: string
  more: string
  month: string
  moreFeatures: string
  mostPopular: string
  upgrade: string
  
  // Navigation
  dashboard: string
  adminPanel: string
  monitorPanel: string
  userManagement: string
  businessManagement: string
  paymentManagement: string
  campaignManagement: string
  campaignManagementDescription: string
  advertisingCampaigns: string
  createCampaign: string
  editCampaign: string
  deleteCampaign: string
  deleteCampaignDescription: string
  campaignName: string
  campaignDescription: string
  campaignCreated: string
  campaignUpdated: string
  campaignDeleted: string
  noCampaigns: string
  startDate: string
  endDate: string
  campaignNameRequired: string
  campaignNamePlaceholder: string
  campaignDescriptionPlaceholder: string
  createCampaignDescription: string
  editCampaignDescription: string
  campaignDetails: string
  businessDetails: string
  campaignStatusDescription: string
  endDateMustBeAfterStartDate: string
  pleaseFillRequiredFields: string
  statistics: string
  visits: string
  last24Hours: string
  totalOrders: string
  totalVisits: string
  totalScans: string
  allTime: string
  businessPerformanceOverview: string
  ordersBreakdown: string
  pendingOrders: string
  awaitingProcessing: string
  completedOrders: string
  successfullyDelivered: string
  engagementMetrics: string
  uniqueVisitors: string
  distinctUsers: string
  qrCodeScans: string
  statisticsComingSoon: string
  statisticsInfo: string
  filterByDate: string
  selectDateRange: string
  fromDate: string
  toDate: string
  selectFromDate: string
  selectToDate: string
  invalidDateRange: string
  filterApplied: string
  filterCleared: string
  activeFilter: string
  from: string
  to: string
  allCampaigns: string
  activeCampaigns: string
  inactiveCampaigns: string
  download: string
  downloadQRCode: string
  qrCodeDownloaded: string
  menuManagement: string
  analytics: string
  businesses: string
  menus: string
  orders: string
  settings: string
  notifications: string
  logout: string
  confirmLogout: string
  confirmLogoutMessage: string
  
  // Business Management (deprecated - use businessManagement from Navigation)
  editBusiness: string
  businessName: string
  businessDescription: string
  businessAddress: string
  businessPhone: string
  businessType: string
  slug: string
  slugHelperText: string
  businessLogo: string
  uploadLogo: string
  invalidImageFile: string
  fileTooLarge: string
  logoUploaded: string
  selectLogoImage: string
  currentLogo: string
  logoPreview: string
  clickToSelectImage: string
  businessColor: string
  businessColorHelperText: string
  
  qrCode: string
  
  // Menu
  menu: string
  categories: string
  items: string
  menuItem: string
  price: string
  available: string
  unavailable: string
  addToCart: string
  
  // Cart messages
  itemNotAvailable: string
  itemAddedToCart: string
  itemQuantityUpdated: string
  itemRemovedFromCart: string
  cartCleared: string
  shoppingCart: string
  cartEmpty: string
  addItemsFromMenu: string
  confirmOrder: string
  orderConfirmed: string
  thankYouContactSoon: string
  clearCart: string
  clearCartConfirm: string
  clearCartConfirmMessage: string
  
  // Status
  online: string
  offline: string
  
  // Dashboard
  welcomeMessage: string
  totalBusinesses: string
  todayOrders: string
  menuItems: string
  totalRevenue: string
  quickActions: string
  quickActionsDescription: string
  createNewBusiness: string
  manageMenus: string
  noBusinessesYet: string
  createBusiness: string
  businessCreatedSuccessfully: string
  businessUpdated: string
  businessNotFound: string
    updateBusinessLogo: string
    basicInformation: string
    contactInformation: string
    taxFee: string
  taxFeeManagement: string
  taxFeeDescription: string
  taxFeeHelperText: string
  taxFeeUpdated: string
  example: string
  forOrderOf: string
  taxWillBe: string
  totalAmount: string
  currency: string
  invalidValue: string
  manage: string
  viewAll: string
  soon: string
  
  // Business Management Page
  businessManagementTitle: string
  businessManagementDescription: string
  addNewBusiness: string
  noBusinesses: string
  noBusinessesDescription: string
  noDescription: string
  active: string
  inactive: string
  confirmDelete: string
  deleteBusiness: string
  deleteBusinessMessage: string
  deleteBusinessDetails: string
  businessDeleted: string
  confirmDeleteSlug: string
  slugMismatch: string
  noResults: string
  noResultsDescription: string
  
  backToBusinesses: string
  acceptingOrders: string
  notAcceptingOrders: string
  showQRCode: string
  invalidBusinessId: string
  
  addressRequired: string
  addressTooLong: string
  phoneRequired: string
  phoneTooLong: string
  addressPlaceholder: string
  phonePlaceholder: string
  qrNote: string
  note: string
  
  // Validation Messages
  validationError: string
  fieldRequired: string
  fieldTooLong: string
  fieldTooShort: string
  invalidFormat: string
  invalidPhoneFormat: string
  duplicateValue: string
  serverError: string
  
  businessInformation: string
  timestamps: string
  createdAt: string
  lastUpdated: string
  address: string
  phoneNumber: string
  qrCodeGenerated: string
  businessStatus: string
  toggleOrders: string
  startAcceptingOrders: string
  stopAcceptingOrders: string
  viewQRCode: string
  viewPublicMenu: string
  invalidParameters: string
  viewDetails: string
  
  // Menu Management Errors
  categoryDeleteError: string
  categoryDeleteNotFound: string
  categoryDeleteUnauthorized: string
  categoryDeleteNetworkError: string
  categoryDeletedSuccessfully: string
  itemDeleteError: string
  itemDeleteNotFound: string
  itemDeleteUnauthorized: string
  itemDeleteNetworkError: string
  itemDeletedSuccessfully: string
  
  // Menu Management Page
  menuManagementTitle: string
  selectBusiness: string
  noBusinessesFound: string
  noBusinessesFoundDescription: string
  manageBusinesses: string
  category: string
  categoryCount: string
  addNewCategory: string
  editCategory: string
  editItem: string
  noCategories: string
  createNewCategory: string
  updating: string
  itemCount: string
  item: string
  allItems: string
  addNewItem: string
  createCategoryFirst: string
  noItemsInCategory: string
  noItems: string
  menuItemsTitle: string
  menuItemsDescription: string
  menuCategoriesTitle: string
  menuCategoriesDescription: string
  searchItemPlaceholder: string
  noSearchResults: string
  tryDifferentSearch: string
  startAddingItems: string
  mustCreateCategoryFirst: string
  refreshPage: string
  uploadImage: string
  confirmDeleteImage: string
  enable: string
  disable: string
  restaurantMenu: string
  deleteCategory: string
  deleteItem: string
  deleteItemConfirm: string
  deleteCategoryConfirm: string
  cannotUndo: string
  selectBusinessToManageMenu: string
  image: string
  name: string
  description: string
  status: string
  actions: string
  
  menuAccess: string
  shareMenuWithCustomers: string
    qrCodePreview: string
    scanToViewMenu: string
    menuLink: string
  copy: string
  copied: string
  failedToCopy: string
  linkCopied: string
  copyFailed: string
  viewFullQRCode: string
  shareMenu: string
  quickStats: string
  menuStatus: string
  publicAccess: string
  enabled: string
  
  // Homepage
  homepagePlatformDescription: string
  homepageTitle: string
  homepageTitleSecondary: string
  homepageDescription: string
  homepageStartFree: string
  homepageSignIn: string
  homepageStatsFree: string
  homepageStatsMin: string
  homepageStatsSupport: string
  homepageFeaturesTitle: string
  homepageFeaturesDescription: string
  homepageFeatureQRCode: string
  homepageFeatureQRCodeDesc: string
  homepageFeatureWhatsApp: string
  homepageFeatureWhatsAppDesc: string
  homepageFeatureAnalytics: string
  homepageFeatureAnalyticsDesc: string
  homepageFeatureQuick: string
  homepageFeatureQuickDesc: string
  homepageFeatureResponsive: string
  homepageFeatureResponsiveDesc: string
  homepageFeatureSales: string
  homepageFeatureSalesDesc: string
  homepageBenefitsTitle: string
  homepageBenefitsDescription: string
  homepageBenefit1: string
  homepageBenefit2: string
  homepageBenefit3: string
  homepageBenefit4: string
  homepageBenefit5: string
  homepageBenefit6: string
  homepageStartFreeNow: string
  homepageHowToStartTitle: string
  homepageHowToStartDescription: string
  homepageStep1Title: string
  homepageStep1Description: string
  homepageStep2Title: string
  homepageStep2Description: string
  homepageStep3Title: string
  homepageStep3Description: string
  homepageCTATitle: string
  homepageCTADescription: string
  homepageCTACreateAccount: string
  homepageFooterQuickLinks: string
  homepageFooterContact: string
  homepageFooterRegister: string
  homepageFooterAllRightsReserved: string
  homepageContactFacebook: string
  homepageContactInstagram: string
  homepageContactWhatsApp: string
  homepageClose: string
  homepageZoomIn: string
  homepageZoomOut: string
  homepagePressEscToClose: string
  homepageZoomedImage: string
  homepageQRCard: string
  homepageDigitalMenu: string
  homepageWhyHatli: string
  
  // Login Page
  loginWelcomeBackTo: string
  loginFeatureMenuManagement: string
  loginFeatureOrderTracking: string
  loginFeatureCustomerExperience: string
  loginSignInToAccount: string
  loginDontHaveAccount: string
  loginSignUpForFree: string
  loginAccountType: string
  loginBusinessOwner: string
  loginAdministrator: string
  loginPhoneNumber: string
  loginPassword: string
  loginPasswordPlaceholder: string
  loginSignIn: string
  loginSigningIn: string
  loginQuickTestLogin: string
  loginBusinessOwners: string
  loginAdministrators: string
  loginTermsAgreement: string
  loginSuccess: string
  loginInvalidCredentials: string
  loginFailed: string
  loginQuickLoginSuccess: string
    loginQuickLoginFailed: string
    loginValidationPhoneFormat: string
    loginValidationPasswordRequired: string
    loginLoggedInAsAdmin: string
    loginLoggedInAsBusinessOwner: string
    loginRememberMe: string
    loginForgotPassword: string
    
    // Registration Validation
    registerValidationNameMin: string
    registerValidationEmailInvalid: string
    registerValidationPasswordMin: string
    registerValidationPasswordMismatch: string
    
    
    // Business Validation
    businessValidationNameMin: string
    businessValidationNameMax: string
    businessValidationDescriptionMax: string
    businessValidationAddressMin: string
    businessValidationAddressMax: string
    businessValidationTypeRequired: string
    
    // Category Validation
    categoryValidationNameMin: string
    categoryValidationNameMax: string
    categoryValidationDescriptionMax: string
    categoryValidationNameRequired: string
    categoryValidationSortOrderPositive: string
    categoryNameLabel: string
    categorySortOrderLabel: string
    categorySortOrderHelper: string
    categoryActiveLabel: string
    categorySelectPlaceholder: string
    categoryRequired: string
    
    // Item Validation
    itemValidationNameMin: string
    itemValidationNameMax: string
    itemValidationDescriptionMax: string
    itemValidationPriceMin: string
    itemValidationPriceMax: string
    itemValidationCategoryRequired: string
    itemValidationNameRequired: string
    itemValidationPriceRequired: string
    itemValidationPriceInvalid: string
    itemValidationPriceMinValue: string
    itemValidationSortOrderPositive: string
    itemNameLabel: string
    itemDescriptionLabel: string
    itemDescriptionOptional: string
    itemPriceLabel: string
    itemSortOrderLabel: string
    itemSortOrderHelper: string
    itemAvailableLabel: string
    itemDescriptionPlaceholder: string
    itemNamePlaceholder: string
    itemCategoryPlaceholder: string
    
    // Customer Info Modal
    customerInformation: string
    enterDetailsToCompleteOrder: string
    customerName: string
    customerNamePlaceholder: string
    customerPhone: string
    customerPhonePlaceholder: string
    addressNotRequired: string
    enterDeliveryAddress: string
    pleaseEnterName: string
    pleaseEnterWhatsApp: string
    pleaseEnterDeliveryAddress: string
    restaurantWhatsAppNotAvailable: string
    sending: string
    sendWhatsApp: string
    customerData: string
    enjoyExperience: string
    thanksForChoosing: string
    forMoreOrders: string
    
  // Password Validation
  changePasswordValidationCurrentRequired: string
  passwordRequired: string
  
  // Access Denied
  accessDeniedTitle: string
  accessDeniedDescription: string
  accessDeniedContactAdmin: string
  accessDeniedGoToDashboard: string
  accessDeniedHomePage: string
  accessDeniedRequestPermission: string
  
  // 404 Not Found Page
  notFoundTitle: string
  notFoundDescription: string
  notFoundMessage: string
  notFoundGoToHome: string
  notFoundGoBack: string

  // User Roles
  userRoleSystemAdmin: string
  userRoleMonitor: string
  userRoleBusinessOwner: string
  userRoleEmployee: string
  userRoleClient: string
  userRoleCashier: string
  
  // User Management
  userManagementDescription: string
  addUser: string
  editUser: string
  deleteUser: string
  searchUsers: string
  noUsers: string
  noUsersDescription: string
  userCreated: string
  userUpdated: string
  userDeleted: string
  failedToGetUsers: string
  failedToCreateUser: string
  failedToUpdateUser: string
  failedToDeleteUser: string
  failedToSaveUser: string
  nameAndPhoneRequired: string
  namePhoneAndEmailRequired: string
  nameRequired: string
  phoneNumberRequired: string
  emailRequired: string
  enterName: string
  enterPhoneNumber: string
  enterEmail: string
  enterPassword: string
  enterNewPassword: string
  confirmDeleteUser: string
  thisActionCannotBeUndone: string
  leaveEmptyToKeepCurrent: string
  user: string
  users: string
  contact: string
  password: string
  userActiveDescription: string
  userInactiveDescription: string
  
  
  // Admin Permissions
  adminPermissionManageUsers: string
  adminPermissionManageBusinesses: string
  adminPermissionManagePayments: string
  adminPermissionViewAnalytics: string
  adminPermissionSystemAdmin: string
  
  // Analytics Event Types
  analyticsEventTypeVisit: string
  analyticsEventTypeOrder: string
  analyticsEventTypeScan: string
  
  // Business Types
  businessTypeRestaurant: string
  businessTypeCafe: string
  businessTypeShop: string
  businessTypeOther: string
  
  // Order Status
  orderStatusPending: string
  orderStatusPreparing: string
  orderStatusReady: string
  orderStatusCompleted: string
  orderStatusCancelled: string
  
  // Order Types
  orderTypePickup: string
  orderTypeDelivery: string
  orderTypeTable: string
  
  // Settings Page
  adminSettingsDescription: string
  monitorSettingsDescription: string
  businessSettingsDescription: string
  profileSettings: string
  profileSettingsDescription: string
  securitySettings: string
  securitySettingsDescription: string
  systemSettings: string
  systemSettingsDescription: string
  systemSettingsComingSoon: string
  notificationSettings: string
  notificationSettingsDescription: string
  preferences: string
  preferencesDescription: string
  accountInformation: string
  accountInformationDescription: string
  fullName: string
  email: string
  phoneNumberCannotBeChanged: string
  currentPassword: string
  newPassword: string
  confirmPassword: string
  changePassword: string
  passwordMinLength: string
  allFieldsRequired: string
  passwordsDoNotMatch: string
  passwordMustBeAtLeast8Characters: string
  emailNotifications: string
  receiveEmailNotifications: string
  notificationSettingsNote: string
  language: string
  selectPreferredLanguage: string
    preferencesNote: string
    arabic: string
    english: string
    role: string
    monitor: string
    accountStatus: string
    memberSince: string
  
  // Privacy & Data Settings
    privacyAndData: string
    privacyAndDataDescription: string
    showEmailInProfile: string
    allowOthersToSeeYourEmail: string
    showActivityStatus: string
    showWhenYouAreOnline: string
    autoSaveData: string
    automaticallySaveYourSettings: string
    privacySettingsNote: string
    profileUpdatedSuccessfully: string
    failedToUpdateProfile: string
    passwordChangedSuccessfully: string
    pleaseLoginAgain: string
    failedToChangePassword: string
    failedToLoadPaymentAccounts: string
    accountDeletedSuccessfully: string
    
    // Payment Accounts
    paymentAccounts: string
    paymentAccountsDescription: string
    addAccount: string
    noPaymentAccounts: string
    addFirstAccount: string
    visible: string
    hidden: string
    confirmDeleteAccount: string
    deleteAccount: string
    editAccount: string
    paymentAccountDescription: string
    paymentMethod: string
    vodafoneCash: string
    orangeMoney: string
    etisalatCash: string
    weCash: string
    instapay: string
    other: string
    accountNumber: string
    accountName: string
    makeVisibleToBusinessOwners: string
    notes: string
    accountNotesPlaceholder: string
    updateAccount: string
    accountUpdated: string
    accountAdded: string
    accountDeleted: string
    confirmDeleteMessage: string
    confirmDeleteAccountMessage: string
    
    // Notifications & Data Settings
    notificationsAndData: string
    inAppNotifications: string
    receiveInAppNotifications: string
    showRenewalDates: string
    dataManagement: string
    dataManagementDescription: string
    accountManagement: string
    businessManagementSettings: string
    businessManagementSettingsDescription: string
    orderSettings: string
    autoAcceptOrders: string
    autoAcceptOrdersDescription: string
    enableDelivery: string
    enableDeliveryDescription: string
    enablePickup: string
    enablePickupDescription: string
    enableTableService: string
    enableTableServiceDescription: string
    sendOrderNotifications: string
    sendOrderNotificationsDescription: string
    sendPaymentNotifications: string
    sendPaymentNotificationsDescription: string
    sendCustomerNotifications: string
    sendCustomerNotificationsDescription: string
    inventorySettings: string
    enableInventoryTracking: string
    enableInventoryTrackingDescription: string
    enableLowStockAlerts: string
    enableLowStockAlertsDescription: string
    settingsSavedSuccessfully: string
    failedToSaveSettings: string
    exportData: string
    export: string
    downloadYourAccountData: string
    dataExportedSuccessfully: string
    deleteAccountPermanently: string
    confirmDeleteAccountMessageFull: string
    accountDeleteRequestSubmitted: string
    typeLast5Digits: string
    incorrectPhoneDigits: string
}

const translations: Record<Language, TranslationKeys> = {
  ar: {
    // Site Info
    siteName: 'Hatli',
    siteDescription: 'منصة لإدارة المنيو والطلبات',
    
    // Common
    loading: 'جاري التحميل...',
    error: 'خطأ',
    success: 'نجح',
    cancel: 'إلغاء',
    save: 'حفظ',
    saving: 'جاري الحفظ...',
    delete: 'حذف',
    edit: 'تعديل',
    create: 'إنشاء',
    search: 'بحث',
    back: 'رجوع',
    next: 'التالي',
    previous: 'السابق',
    close: 'إغلاق',
    more: 'المزيد',
    month: 'شهر',
    moreFeatures: 'ميزة أخرى',
    mostPopular: 'الأكثر طلباً',
    upgrade: 'ترقية',
    
    // Navigation
    dashboard: 'لوحة التحكم',
    adminPanel: 'لوحة التحكم الإدارية',
    monitorPanel: 'لوحة التحكم لمسئول النظام',
    userManagement: 'إدارة المستخدمين',
    businessManagement: 'إدارة الأعمال التجارية',
    paymentManagement: 'إدارة المدفوعات',
    campaignManagement: 'إدارة الحملات الإعلانية',
    campaignManagementDescription: 'إدارة وتنظيم حملاتك الإعلانية والتسويقية',
    advertisingCampaigns: 'الحملات الإعلانية',
    createCampaign: 'إنشاء حملة إعلانية',
    editCampaign: 'تعديل الحملة الإعلانية',
    deleteCampaign: 'حذف الحملة الإعلانية',
    deleteCampaignDescription: 'هل أنت متأكد من أنك تريد حذف هذه الحملة الإعلانية؟ لا يمكن التراجع عن هذا الإجراء.',
    campaignName: 'اسم الحملة الإعلانية',
    campaignDescription: 'وصف الحملة الإعلانية',
    campaignCreated: 'تم إنشاء الحملة الإعلانية بنجاح',
    campaignUpdated: 'تم تحديث الحملة الإعلانية بنجاح',
    campaignDeleted: 'تم حذف الحملة الإعلانية بنجاح',
    noCampaigns: 'لا توجد حملات إعلانية',
    startDate: 'تاريخ البدء',
    endDate: 'تاريخ الانتهاء',
    campaignNameRequired: 'اسم الحملة مطلوب',
    campaignNamePlaceholder: 'أدخل اسم الحملة',
    campaignDescriptionPlaceholder: 'أدخل وصف الحملة (اختياري)',
    createCampaignDescription: 'إنشاء حملة إعلانية جديدة',
    editCampaignDescription: 'تعديل تفاصيل الحملة',
    campaignDetails: 'تفاصيل الحملة',
    businessDetails: 'تفاصيل العمل التجاري',
    campaignStatusDescription: 'الحملات النشطة ستكون مرئية ويمكنها استقبال عمليات المسح',
    endDateMustBeAfterStartDate: 'تاريخ الانتهاء يجب أن يكون بعد تاريخ البدء',
    pleaseFillRequiredFields: 'يرجى ملء جميع الحقول المطلوبة',
    statistics: 'الإحصائيات',
    visits: 'الزيارات',
    last24Hours: 'آخر 24 ساعة',
    totalOrders: 'إجمالي الطلبات',
    totalVisits: 'إجمالي الزيارات',
    totalScans: 'إجمالي عمليات المسح',
    allTime: 'جميع الأوقات',
    businessPerformanceOverview: 'نظرة عامة على الأداء',
    ordersBreakdown: 'تفاصيل الطلبات',
    pendingOrders: 'الطلبات المعلقة',
    awaitingProcessing: 'في انتظار المعالجة',
    completedOrders: 'الطلبات المكتملة',
    successfullyDelivered: 'تم تسليمها بنجاح',
    engagementMetrics: 'مقاييس التفاعل',
    uniqueVisitors: 'زوار فريدون',
    distinctUsers: 'مستخدمون مميزون',
    qrCodeScans: 'عمليات مسح QR',
    statisticsComingSoon: 'الإحصائيات قريباً',
    statisticsInfo: 'سيتم عرض الإحصائيات التفصيلية بمجرد بدء استقبال الطلبات والزيارات. تابع أداء عملك التجاري من هنا.',
    filterByDate: 'فلترة حسب التاريخ',
    selectDateRange: 'اختر نطاق التاريخ لعرض الإحصائيات',
    fromDate: 'من تاريخ',
    toDate: 'إلى تاريخ',
    selectFromDate: 'اختر تاريخ البداية',
    selectToDate: 'اختر تاريخ النهاية',
    invalidDateRange: 'تاريخ البداية يجب أن يكون قبل تاريخ النهاية',
    filterApplied: 'تم تطبيق الفلتر',
    filterCleared: 'تم مسح الفلتر',
    activeFilter: 'الفلتر النشط:',
    from: 'من',
    to: 'إلى',
    allCampaigns: 'جميع الحملات',
    activeCampaigns: 'الحملات النشطة',
    inactiveCampaigns: 'الحملات غير النشطة',
    download: 'تحميل',
    downloadQRCode: 'تحميل رمز QR',
    qrCodeDownloaded: 'تم تحميل رمز QR بنجاح',
    menuManagement: 'إدارة المنيو',
    analytics: 'التحليلات',
    businesses: 'الأعمال التجارية',
    menus: 'القوائم',
    orders: 'الطلبات',
    settings: 'الإعدادات',
    notifications: 'الإشعارات',
    logout: 'تسجيل الخروج',
    confirmLogout: 'تأكيد تسجيل الخروج',
    confirmLogoutMessage: 'هل أنت متأكد من أنك تريد تسجيل الخروج؟ ستحتاج إلى تسجيل الدخول مرة أخرى للوصول إلى حسابك.',
    
    // Business Management
    editBusiness: 'تعديل العمل التجاري',
    businessName: 'الاسم',
    businessDescription: 'الوصف',
    businessAddress: 'العنوان',
    businessPhone: 'الهاتف',
    businessType: 'تصنيف العمل',
    slug: 'رابط المنيو',
    slugHelperText: 'معرف URL للعمل التجاري (مثال: my-business-name)',
    businessLogo: 'شعار العمل التجاري',
    uploadLogo: 'رفع الشعار',
    invalidImageFile: 'يرجى اختيار ملف صورة صالح',
    fileTooLarge: 'حجم الملف كبير جداً. الحد الأقصى 2 ميجابايت',
    logoUploaded: 'تم رفع الشعار بنجاح',
    selectLogoImage: 'اختر صورة للشعار (PNG, JPG, JPEG - حد أقصى 2 ميجابايت)',
    currentLogo: 'اللوجو الحالي',
    logoPreview: 'معاينة اللوجو الجديد',
    clickToSelectImage: 'انقر لاختيار صورة أو اسحب الملف هنا',
    businessColor: 'لون الهوية',
    businessColorHelperText: 'اختر لون الهوية الخاص بك (يُستخدم في المنيو)',
    
    qrCode: 'رمز QR',
    
    // Menu
    menu: 'المنيو',
    categories: 'الفئات',
    items: 'العناصر',
    menuItem: 'عنصر القائمة',
    price: 'السعر',
    available: 'متوفر',
    unavailable: 'غير متوفر',
    addToCart: 'إضافة للسلة',
    
    // Cart messages
    itemNotAvailable: 'هذا الصنف غير متوفر',
    itemAddedToCart: 'تم إضافة الصنف للسلة',
    itemQuantityUpdated: 'تم تحديث الكمية',
    itemRemovedFromCart: 'تم حذف الصنف من السلة',
    cartCleared: 'تم مسح السلة',
    shoppingCart: 'سلة المشتريات',
    cartEmpty: 'السلة فارغة',
    addItemsFromMenu: 'أضف بعض العناصر من القائمة',
    confirmOrder: 'تأكيد الطلب',
    orderConfirmed: 'تم تأكيد الطلب بنجاح!',
    thankYouContactSoon: 'شكراً لك، سنتواصل معك قريباً',
    clearCart: 'مسح السلة',
    clearCartConfirm: 'تأكيد مسح السلة',
    clearCartConfirmMessage: 'هل أنت متأكد من مسح جميع العناصر من السلة؟',
    
    // Status
    online: 'متصل',
    offline: 'غير متصل',
    
    // Dashboard
    welcomeMessage: 'مرحباً بك في منصة القوائم الرقمية',
    totalBusinesses: 'الأعمال التجارية',
    todayOrders: 'الطلبات اليوم',
    menuItems: 'القوائم',
    totalRevenue: 'إجمالي الإيرادات',
    quickActions: 'الإجراءات السريعة',
    quickActionsDescription: 'ابدأ بإدارة أعمالك التجارية',
    manageBusinesses: 'إدارة الأعمال التجارية',
    createNewBusiness: 'إنشاء عمل تجاري جديد',
    manageMenus: 'إدارة القوائم',
    noBusinessesYet: 'لا توجد أعمال تجارية بعد',
    createBusiness: 'إنشاء عمل تجاري',
    businessCreatedSuccessfully: 'تم إنشاء العمل التجاري بنجاح',
    businessUpdated: 'تم تحديث العمل بنجاح',
    businessNotFound: 'العمل التجاري غير موجود',
    updateBusinessLogo: 'تحديث اللوجو',
    basicInformation: 'المعلومات الأساسية',
    contactInformation: 'معلومات الاتصال',
    taxFee: 'الضريبة',
    taxFeeManagement: 'إدارة الضريبة',
    taxFeeDescription: 'إدارة نسبة الضريبة المطبقة على الطلبات',
    taxFeeHelperText: 'نسبة الضريبة كنسبة مئوية (مثال: 5 يعني 5%)',
    taxFeeUpdated: 'تم تحديث نسبة الضريبة بنجاح',
    example: 'مثال على الحساب',
    forOrderOf: 'لطلب بقيمة',
    taxWillBe: 'ستكون الضريبة',
    totalAmount: 'المبلغ الإجمالي',
    currency: 'جنيه',
    invalidValue: 'قيمة غير صحيحة. يجب أن تكون بين 0 و 100',
    manage: 'إدارة',
    viewAll: 'عرض الكل',
    soon: 'قريباً',
    
    // Business Management Page
    businessManagementTitle: 'إدارة الأعمال',
    businessManagementDescription: 'قم بإدارة أعمالك',
    addNewBusiness: 'إضافة عمل تجاري جديد',
    noBusinesses: 'لا توجد أعمال تجارية',
    noBusinessesDescription: 'ابدأ بإنشاء عملك التجاري الأول لإدارة القوائم والطلبات',
    noDescription: 'لا يوجد وصف',
    active: 'نشط',
    inactive: 'غير نشط',
    confirmDelete: 'هل أنت متأكد من حذف',
    deleteBusiness: 'حذف العمل التجاري',
    deleteBusinessMessage: 'هل أنت متأكد من حذف العمل التجاري "{name}" نهائياً؟',
    deleteBusinessDetails: 'سيتم حذف جميع البيانات المرتبطة بهذا العمل التجاري نهائياً ولا يمكن التراجع عن هذا الإجراء، بما في ذلك:\n• جميع الفروع\n• جميع القوائم والمنتجات\n• جميع الحملات الإعلانية\n• جميع الطلبات والسجلات\n• جميع الإحصائيات والتحليلات',
    businessDeleted: 'تم حذف العمل التجاري بنجاح',
    confirmDeleteSlug: 'لتأكيد الحذف، يرجى إدخال slug العمل التجاري:',
    slugMismatch: 'Slug غير صحيح. يرجى إدخال slug صحيح للتأكيد.',
    noResults: 'لا توجد نتائج',
    noResultsDescription: 'لم يتم العثور على أعمال تجارية تطابق البحث',
    
    backToBusinesses: 'العودة للأعمال التجارية',
    acceptingOrders: 'يستقبل طلبات',
    notAcceptingOrders: 'لا يستقبل طلبات',
    showQRCode: 'عرض رمز QR',
    invalidBusinessId: 'معرف العمل التجاري غير صحيح',
    
    addressRequired: 'العنوان مطلوب',
    addressTooLong: 'العنوان طويل جداً (الحد الأقصى 200 حرف)',
    phoneRequired: 'رقم الهاتف مطلوب',
    phoneTooLong: 'رقم الهاتف طويل جداً (الحد الأقصى 20 رقم)',
    addressPlaceholder: 'العنوان الكامل',
    phonePlaceholder: '01xxxxxxxxx',
    qrNote: 'سيتم إنشاء رمز QR فريد تلقائياً بعد الإنشاء.',
    note: 'ملاحظة:',
    
    // Validation Messages
    validationError: 'خطأ في التحقق من صحة البيانات',
    fieldRequired: 'هذا الحقل مطلوب',
    fieldTooLong: 'القيمة طويلة جداً',
    fieldTooShort: 'القيمة قصيرة جداً',
    invalidFormat: 'تنسيق غير صحيح',
    invalidPhoneFormat: 'تنسيق رقم الهاتف غير صحيح. يجب أن يبدأ بـ 01 ويحتوي على 11 رقم',
    duplicateValue: 'هذه القيمة موجودة مسبقاً',
    serverError: 'خطأ في الخادم',
    
    businessInformation: 'معلومات العمل التجاري',
    timestamps: 'التواريخ والأوقات',
    createdAt: 'تاريخ الإنشاء',
    lastUpdated: 'آخر تحديث',
    address: 'العنوان',
    phoneNumber: 'رقم الهاتف',
    qrCodeGenerated: 'تم إنشاء رمز QR',
    businessStatus: 'حالة العمل التجاري',
    toggleOrders: 'تبديل الطلبات',
    startAcceptingOrders: 'استقبال الطلبات',
    stopAcceptingOrders: 'إيقاف الطلبات',
    viewQRCode: 'عرض رمز QR',
    viewPublicMenu: 'عرض القائمة العامة',
    invalidParameters: 'معاملات غير صحيحة',
    viewDetails: 'عرض التفاصيل',
    
    // Menu Management Errors
    categoryDeleteError: 'فشل حذف التصنيف',
    categoryDeleteNotFound: 'التصنيف غير موجود أو تم حذفه بالفعل',
    categoryDeleteUnauthorized: 'ليس لديك صلاحية لحذف هذا التصنيف',
    categoryDeleteNetworkError: 'حدث خطأ في الاتصال. يرجى المحاولة مرة أخرى',
    categoryDeletedSuccessfully: 'تم حذف التصنيف بنجاح',
    itemDeleteError: 'فشل حذف الصنف',
    itemDeleteNotFound: 'الصنف غير موجود أو تم حذفه بالفعل',
    itemDeleteUnauthorized: 'ليس لديك صلاحية لحذف هذا الصنف',
    itemDeleteNetworkError: 'حدث خطأ في الاتصال. يرجى المحاولة مرة أخرى',
    itemDeletedSuccessfully: 'تم حذف الصنف بنجاح',
    
    // Menu Management Page
    menuManagementTitle: 'إدارة اصناف واسعار المنيو',
    selectBusiness: 'اختر العمل',
    noBusinessesFound: 'لا توجد أعمال تجارية',
    noBusinessesFoundDescription: 'يجب إنشاء عمل تجاري أولاً لإدارة المنيو',
    category: 'تصنيف',
    categoryCount: 'تصنيف',
    addNewCategory: 'إضافة تصنيف جديد',
    editCategory: 'تعديل التصنيف',
    editItem: 'تعديل الصنف',
    noCategories: 'لا توجد تصنيفات',
    createNewCategory: 'إنشاء تصنيف جديد',
    updating: 'جاري التحديث...',
    itemCount: 'صنف',
    item: 'صنف',
    allItems: 'جميع الأصناف',
    addNewItem: 'إضافة صنف جديد',
    createCategoryFirst: 'يجب إنشاء تصنيف أولاً لإضافة أصناف',
    noItemsInCategory: 'لا توجد أصناف في هذا التصنيف',
    noItems: 'لا توجد أصناف',
    menuItemsTitle: 'أصناف المنيو',
    menuItemsDescription: 'قم بإدارة أصناف المنيو وأسعارها',
    menuCategoriesTitle: 'تصنيفات المنيو',
    menuCategoriesDescription: 'قم بإدارة تصنيفات المنيو وترتيبها',
    searchItemPlaceholder: 'ابحث عن صنف بالاسم أو الوصف...',
    noSearchResults: 'لا توجد نتائج للبحث',
    tryDifferentSearch: 'جرب البحث بكلمات مختلفة أو اختر تصنيف آخر',
    startAddingItems: 'ابدأ بإضافة أصناف جديدة للمنيو',
    mustCreateCategoryFirst: 'يجب إنشاء تصنيف واحد على الأقل قبل إضافة الأصناف',
    refreshPage: 'تحديث الصفحة',
    uploadImage: 'رفع صورة',
    confirmDeleteImage: 'هل أنت متأكد من حذف الصورة؟',
    enable: 'تفعيل',
    disable: 'إلغاء التفعيل',
    restaurantMenu: 'قائمة المطعم',
    deleteItemConfirm: 'هل أنت متأكد من حذف الصنف',
    deleteCategoryConfirm: 'هل أنت متأكد من حذف التصنيف',
    cannotUndo: 'لا يمكن التراجع عن هذا الإجراء',
    deleteCategory: 'حذف التصنيف',
    deleteItem: 'حذف الصنف',
    selectBusinessToManageMenu: 'اختر عمل تجاري من القائمة أعلاه لإدارة المنيو',
    image: 'الصورة',
    name: 'الاسم',
    description: 'الوصف',
    status: 'الحالة',
    actions: 'الإجراءات',
  
    menuAccess: 'الوصول للمنيو',
    shareMenuWithCustomers: 'شارك المنيو مع العملاء',
    qrCodePreview: 'معاينة رمز QR',
    scanToViewMenu: 'امسح لرؤية المنيو',
    menuLink: 'رابط المنيو',
    copy: 'نسخ',
    copied: 'تم النسخ',
    failedToCopy: 'فشل النسخ',
    linkCopied: 'تم نسخ الرابط بنجاح',
    copyFailed: 'فشل في نسخ الرابط',
    viewFullQRCode: 'عرض رمز QR',
    shareMenu: 'مشاركة المنيو',
    quickStats: 'الإحصائيات السريعة',
    menuStatus: 'حالة القائمة',
    publicAccess: 'الوصول العام',
    enabled: 'مفعل',
    
    // Homepage
    homepagePlatformDescription: 'منصة لإدارة المنيو والطلبات',
    homepageTitle: 'تحكّم في المنيو، الأسعار، والطلبات',
    homepageTitleSecondary: 'من مكان واحد',
    homepageDescription: 'أنشئ منيو تفاعلي مع QR Code ونظام طلبات متكامل عبر واتساب. مثالي للمطاعم والمقاهي والمحلات.',
    homepageStartFree: 'ابدأ مجاناً',
    homepageSignIn: 'تسجيل الدخول',
    homepageStatsFree: 'مجاني',
    homepageStatsMin: 'دقائق',
    homepageStatsSupport: 'دعم',
    homepageFeaturesTitle: 'ما نقدمه لك',
    homepageFeaturesDescription: 'خطوات لإدارة المنيو والطلبات بسهولة',
    homepageFeatureQRCode: 'QR Code',
    homepageFeatureQRCodeDesc: 'رموز QR احترافية لعرض المنيو. مسح بسيط ووصول فوري للمنيو',
    homepageFeatureWhatsApp: 'تكامل واتساب',
    homepageFeatureWhatsAppDesc: 'استقبل طلباتك بسهولة وأرسل حالة الطلب للعميل عبر واتساب',
    homepageFeatureAnalytics: 'التحليلات والمتابعة',
    homepageFeatureAnalyticsDesc: 'تابع أداء الحملات وسلوك العملاء والمبيعات بتحليلات مفصلة',
    homepageFeatureQuick: 'سهولة وسرعة',
    homepageFeatureQuickDesc: 'قم بإعداد المنيو وتحديثه في دقائق بدون تعقيد',
    homepageFeatureResponsive: 'متجاوب بالكامل',
    homepageFeatureResponsiveDesc: 'يعمل بشكل مثالي على جميع الأجهزة والهواتف الذكية',
    homepageFeatureSales: 'زيادة المبيعات',
    homepageFeatureSalesDesc: 'حسّن تجربة العملاء وزد من معدلات الطلب والإيرادات',
    homepageBenefitsTitle: 'لماذا Hatli؟',
    homepageBenefitsDescription: 'الحل الأمثل لإدارة المنيو بطريقة احترافية وسهلة',
    homepageBenefit1: 'لا حاجة لطباعة المنيوهات التقليدية',
    homepageBenefit2: 'تحديثات فورية للأسعار والعناصر',
    homepageBenefit3: 'إدارة متعددة الفروع',
    homepageBenefit4: 'تتبع الحملات التسويقية',
    homepageBenefit5: 'دعم متعدد اللغات',
    homepageBenefit6: 'فريق دعم فني جاهز لمساعدتك في أي وقت',
    homepageStartFreeNow: 'ابدأ الآن مجاناً',
    homepageHowToStartTitle: 'كيف تبدأ؟',
    homepageHowToStartDescription: 'ثلاث خطوات بسيطة لبدء استخدام Hatli',
    homepageStep1Title: 'سجّل حسابك',
    homepageStep1Description: 'أنشئ حساب مجاني في دقائق',
    homepageStep2Title: 'أضف المنيو',
    homepageStep2Description: 'ابدأ بإضافة المنتجات وتصنيفها',
    homepageStep3Title: 'شارك QR Code',
    homepageStep3Description: 'احصل على QR Code وابدأ استقبال الطلبات',
    homepageCTATitle: 'جاهز للبدء؟',
    homepageCTADescription: 'ابدأ مجاناً وحسّن تجربة عملائك',
    homepageCTACreateAccount: 'إنشاء حساب مجاني',
    homepageFooterQuickLinks: 'روابط سريعة',
    homepageFooterContact: 'تواصل معنا',
    homepageFooterRegister: 'التسجيل',
    homepageFooterAllRightsReserved: 'جميع الحقوق محفوظة',
    homepageContactFacebook: 'تواصل معنا عبر فيسبوك',
    homepageContactInstagram: 'تواصل معنا عبر انستجرام',
    homepageContactWhatsApp: 'تواصل معنا عبر واتساب',
    homepageClose: 'إغلاق',
    homepageZoomIn: 'تكبير',
    homepageZoomOut: 'تصغير',
    homepagePressEscToClose: 'اضغط ESC للإغلاق',
    homepageZoomedImage: 'صورة مكبرة',
    homepageQRCard: 'بطاقة QR',
    homepageDigitalMenu: 'منيو رقمي',
    homepageWhyHatli: 'لماذا Hatli',
    
    // Login Page
    loginWelcomeBackTo: 'مرحباً بك في',
    loginFeatureMenuManagement: 'إدارة وتحديث القوائم بسهولة',
    loginFeatureOrderTracking: 'تتبع الطلبات والتحليلات في الوقت الفعلي',
    loginFeatureCustomerExperience: 'تجربة عملاء سلسة',
    loginSignInToAccount: 'تسجيل الدخول',
    loginDontHaveAccount: 'ليس لديك حساب؟',
    loginSignUpForFree: 'سجّل مجاناً',
    loginAccountType: 'نوع الحساب',
    loginBusinessOwner: 'صاحب عمل',
    loginAdministrator: 'مدير',
    loginPhoneNumber: 'رقم الهاتف',
    loginPassword: 'كلمة المرور',
    loginPasswordPlaceholder: 'أدخل كلمة المرور',
    loginSignIn: 'تسجيل الدخول',
    loginSigningIn: 'جاري تسجيل الدخول...',
    loginQuickTestLogin: 'تسجيل دخول سريع للاختبار',
    loginBusinessOwners: 'أصحاب الأعمال',
    loginAdministrators: 'المدراء',
    loginTermsAgreement: 'بتسجيل الدخول، أنت توافق على شروط الخدمة وسياسة الخصوصية',
    loginSuccess: 'تم تسجيل الدخول بنجاح!',
    loginInvalidCredentials: 'بيانات الدخول غير صحيحة. يرجى التحقق من رقم الهاتف وكلمة المرور.',
    loginFailed: 'فشل تسجيل الدخول. يرجى المحاولة مرة أخرى.',
    loginQuickLoginSuccess: 'تم تسجيل الدخول بنجاح',
    loginQuickLoginFailed: 'فشل تسجيل الدخول السريع. يرجى المحاولة مرة أخرى.',
    loginValidationPhoneFormat: 'صيغة رقم الهاتف غير صحيحة',
    loginValidationPasswordRequired: 'كلمة المرور مطلوبة',
    loginLoggedInAsAdmin: 'مدير',
    loginLoggedInAsBusinessOwner: 'صاحب عمل',
    loginRememberMe: 'تذكرني',
    loginForgotPassword: 'نسيت كلمة المرور؟',
    
    // Registration Validation
    registerValidationNameMin: 'الاسم يجب أن يكون على الأقل حرفين',
    registerValidationEmailInvalid: 'صيغة البريد الإلكتروني غير صحيحة',
    registerValidationPasswordMin: 'كلمة المرور يجب أن تكون على الأقل 8 أحرف',
    registerValidationPasswordMismatch: 'كلمات المرور غير متطابقة',
    
    
    // Business Validation
    businessValidationNameMin: 'اسم العمل التجاري يجب أن يكون على الأقل حرفين',
    businessValidationNameMax: 'اسم العمل التجاري طويل جداً',
    businessValidationDescriptionMax: 'الوصف طويل جداً',
    businessValidationAddressMin: 'العنوان يجب أن يكون على الأقل 5 أحرف',
    businessValidationAddressMax: 'العنوان طويل جداً',
    businessValidationTypeRequired: 'نوع العمل التجاري مطلوب',
    
    // Category Validation
    categoryValidationNameMin: 'اسم الفئة يجب أن يكون على الأقل حرفين',
    categoryValidationNameMax: 'اسم الفئة طويل جداً',
    categoryValidationDescriptionMax: 'وصف الفئة طويل جداً',
    categoryValidationNameRequired: 'اسم التصنيف مطلوب',
    categoryValidationSortOrderPositive: 'ترتيب التصنيف يجب أن يكون رقم موجب',
    categoryNameLabel: 'اسم التصنيف',
    categorySortOrderLabel: 'ترتيب التصنيف',
    categorySortOrderHelper: 'الرقم الأصغر يظهر أولاً في المنيو',
    categoryActiveLabel: 'تصنيف نشط (ظاهر للعملاء)',
    categorySelectPlaceholder: 'اختر التصنيف',
    categoryRequired: 'يجب اختيار تصنيف',
    
    // Item Validation
    itemValidationNameMin: 'اسم الصنف يجب أن يكون على الأقل حرفين',
    itemValidationNameMax: 'اسم الصنف طويل جداً',
    itemValidationDescriptionMax: 'وصف الصنف طويل جداً',
    itemValidationPriceMin: 'السعر يجب أن يكون على الأقل 0.01',
    itemValidationPriceMax: 'السعر كبير جداً',
    itemValidationCategoryRequired: 'يجب اختيار تصنيف',
    itemValidationNameRequired: 'اسم الصنف مطلوب',
    itemValidationPriceRequired: 'السعر مطلوب',
    itemValidationPriceInvalid: 'السعر يجب أن يكون رقماً',
    itemValidationPriceMinValue: 'السعر يجب أن يكون أكبر من صفر',
    itemValidationSortOrderPositive: 'ترتيب الصنف يجب أن يكون رقم موجب',
    itemNameLabel: 'اسم الصنف',
    itemDescriptionLabel: 'الوصف',
    itemDescriptionOptional: 'اختياري',
    itemPriceLabel: 'السعر',
    itemSortOrderLabel: 'ترتيب الصنف',
    itemSortOrderHelper: 'الرقم الأصغر يظهر أولاً في المنيو',
    itemAvailableLabel: 'متوفر للطلب',
    itemDescriptionPlaceholder: 'وصف الصنف ومكوناته...',
    itemNamePlaceholder: 'مثال: برجر لحم، سلطة خضراء',
    itemCategoryPlaceholder: 'اختر التصنيف',
    
    // Customer Info Modal
    customerInformation: 'معلومات العميل',
    enterDetailsToCompleteOrder: 'أدخل بياناتك لإتمام الطلب',
    customerName: 'الاسم',
    customerNamePlaceholder: 'أدخل اسمك',
    customerPhone: 'رقم الواتساب',
    customerPhonePlaceholder: '05xxxxxxxx',
    addressNotRequired: 'العنوان غير مطلوب',
    enterDeliveryAddress: 'أدخل عنوان التوصيل',
    pleaseEnterName: 'يرجى إدخال الاسم',
    pleaseEnterWhatsApp: 'يرجى إدخال رقم الواتساب',
    pleaseEnterDeliveryAddress: 'يرجى إدخال عنوان التوصيل',
    restaurantWhatsAppNotAvailable: 'رقم الواتساب الخاص بالمطعم غير متوفر',
    sending: 'جاري الإرسال...',
    sendWhatsApp: 'إرسال واتساب',
    customerData: 'بيانات العميل',
    enjoyExperience: 'نتمنى لكم تجربة ممتعة!',
    thanksForChoosing: 'شكراََ لاختياركم',
    forMoreOrders: 'لمزيد من الطلبات:',
    
    // Password Validation
    changePasswordValidationCurrentRequired: 'كلمة المرور الحالية مطلوبة',
    passwordRequired: 'كلمة المرور مطلوبة',
    
    // Access Denied
    accessDeniedTitle: 'ليس لديك صلاحية',
    accessDeniedDescription: 'عذراً، ليس لديك الصلاحية للوصول إلى هذه الصفحة.',
    accessDeniedContactAdmin: 'يرجى التواصل مع المسؤول إذا كنت تعتقد أن هذا خطأ.',
    accessDeniedGoToDashboard: 'العودة الى لوحة التحكم',
    accessDeniedHomePage: 'الصفحة الرئيسية',
    accessDeniedRequestPermission: 'إذا كنت تحتاج إلى الوصول إلى هذه الصفحة، يرجى طلب الصلاحيات المناسبة من المسؤول.',
    
    // 404 Not Found Page
    notFoundTitle: '404',
    notFoundDescription: 'الصفحة التي تبحث عنها غير موجودة.',
    notFoundMessage: 'قد تكون الصفحة تم حذفها أو نقلها أو أن الرابط غير صحيح.',
    notFoundGoToHome: 'الصفحة الرئيسية',
    notFoundGoBack: 'العودة للخلف',
    
    // User Roles
    userRoleSystemAdmin: 'مدير النظام',
    userRoleMonitor: 'مسئول النظام',
    userRoleBusinessOwner: 'مدير مشروع',
    userRoleEmployee: 'موظف',
    userRoleClient: 'عميل',
    userRoleCashier: 'كاشير',
    
    // User Management
    userManagementDescription: 'إدارة المستخدمين و صلاحيتهم',
    addUser: 'إضافة مستخدم',
    editUser: 'تعديل مستخدم',
    deleteUser: 'حذف مستخدم',
    searchUsers: 'البحث عن المستخدمين بالاسم، الهاتف، البريد الإلكتروني، أو الصلاحية...',
    noUsers: 'لا يوجد مستخدمين',
    noUsersDescription: 'ابدأ بإضافة أول مستخدم',
    userCreated: 'تم إنشاء المستخدم بنجاح',
    userUpdated: 'تم تحديث المستخدم بنجاح',
    userDeleted: 'تم حذف المستخدم بنجاح',
    failedToGetUsers: 'فشل تحميل المستخدمين',
    failedToCreateUser: 'فشل إنشاء المستخدم',
    failedToUpdateUser: 'فشل تحديث المستخدم',
    failedToDeleteUser: 'فشل حذف المستخدم',
    failedToSaveUser: 'فشل حفظ المستخدم',
    nameAndPhoneRequired: 'الاسم ورقم الهاتف مطلوبان',
    namePhoneAndEmailRequired: 'الاسم ورقم الهاتف والبريد الإلكتروني مطلوبون',
    nameRequired: 'الاسم مطلوب',
    phoneNumberRequired: 'رقم الهاتف مطلوب',
    emailRequired: 'البريد الإلكتروني مطلوب',
    enterName: 'أدخل الاسم',
    enterPhoneNumber: 'أدخل رقم الهاتف',
    enterEmail: 'أدخل البريد الإلكتروني (اختياري)',
    enterPassword: 'أدخل كلمة المرور',
    enterNewPassword: 'أدخل كلمة المرور الجديدة (اختياري)',
    confirmDeleteUser: 'هل أنت متأكد من حذف',
    thisActionCannotBeUndone: 'لا يمكن التراجع عن هذا الإجراء وسيتم حذف المستخدم وجميع البيانات المرتبطة به نهائياً.',
    leaveEmptyToKeepCurrent: 'اتركه فارغاً للاحتفاظ بالقيمة الحالية',
    user: 'المستخدم',
    users: 'المستخدمين',
    contact: 'جهة الاتصال',
    password: 'كلمة المرور',
    userActiveDescription: 'المستخدم نشط ويمكنه تسجيل الدخول واستخدام النظام',
    userInactiveDescription: 'المستخدم غير نشط ولن يتمكن من تسجيل الدخول',
    
    
    // Admin Permissions
    adminPermissionManageUsers: 'إدارة المستخدمين',
    adminPermissionManageBusinesses: 'إدارة الأعمال',
    adminPermissionManagePayments: 'إدارة المدفوعات',
    adminPermissionViewAnalytics: 'عرض التحليلات',
    adminPermissionSystemAdmin: 'مدير النظام',
    
    // Analytics Event Types
    analyticsEventTypeVisit: 'زيارة',
    analyticsEventTypeOrder: 'طلب',
    analyticsEventTypeScan: 'مسح',
    
    // Business Types
    businessTypeRestaurant: 'مطعم',
    businessTypeCafe: 'كافيه',
    businessTypeShop: 'محل',
    businessTypeOther: 'أخرى',
    
    // Order Status
    orderStatusPending: 'في الانتظار',
    orderStatusPreparing: 'قيد التحضير',
    orderStatusReady: 'جاهز',
    orderStatusCompleted: 'مكتمل',
    orderStatusCancelled: 'ملغي',
    
    // Order Types
    orderTypePickup: 'استلام',
    orderTypeDelivery: 'توصيل',
    orderTypeTable: 'طاولة',
    
    // Settings Page
    adminSettingsDescription: 'إدارة إعدادات حسابك كمدير نظام وتفضيلات النظام',
    monitorSettingsDescription: 'إدارة إعدادات حسابك كمسئول نظام وتفضيلات الحساب',
    businessSettingsDescription: 'إدارة إعدادات حسابك كصاحب عمل أو موظف',
    profileSettings: 'الملف الشخصي',
    profileSettingsDescription: 'قم بتحديث معلوماتك الشخصية',
    securitySettings: 'الأمان',
    securitySettingsDescription: 'غيّر كلمة المرور الخاصة بك للحفاظ على أمان حسابك',
    systemSettings: 'إعدادات النظام',
    systemSettingsDescription: 'تكوين إعدادات النظام الشاملة والتفضيلات',
    systemSettingsComingSoon: 'ستكون إعدادات النظام متاحة قريباً',
    notificationSettings: 'الإشعارات',
    notificationSettingsDescription: 'إدارة طريقة استلامك للإشعارات',
    preferences: 'التفضيلات',
    preferencesDescription: 'تخصيص تفضيلات التطبيق',
    accountInformation: 'معلومات الحساب',
    accountInformationDescription: 'عرض تفاصيل حسابك والصلاحيات',
    fullName: 'الاسم الكامل',
    email: 'البريد الإلكتروني',
    phoneNumberCannotBeChanged: 'لا يمكن تغيير رقم الهاتف',
    currentPassword: 'كلمة المرور الحالية',
    newPassword: 'كلمة المرور الجديدة',
    confirmPassword: 'تأكيد كلمة المرور الجديدة',
    changePassword: 'تغيير كلمة المرور',
    passwordMinLength: 'يجب أن تكون كلمة المرور 8 أحرف على الأقل',
    allFieldsRequired: 'جميع الحقول مطلوبة',
    passwordsDoNotMatch: 'كلمات المرور غير متطابقة',
    passwordMustBeAtLeast8Characters: 'يجب أن تكون كلمة المرور 8 أحرف على الأقل',
    emailNotifications: 'إشعارات البريد الإلكتروني',
    receiveEmailNotifications: 'تلقي الإشعارات عبر البريد الإلكتروني',
    notificationSettingsNote: 'يتم حفظ تفضيلات الإشعارات تلقائياً',
    language: 'اللغة',
    selectPreferredLanguage: 'اختر لغتك المفضلة',
    preferencesNote: 'يتم حفظ التفضيلات في المتصفح',
    arabic: 'العربية',
    english: 'الإنجليزية',
    role: 'الصلاحية',
    monitor: 'مسئول النظام',
    accountStatus: 'حالة الحساب',
    memberSince: 'عضو منذ',
    
    // Privacy & Data Settings
    privacyAndData: 'الخصوصية والبيانات',
    privacyAndDataDescription: 'إدارة إعدادات الخصوصية وتفضيلات البيانات',
    showEmailInProfile: 'إظهار البريد الإلكتروني في الملف الشخصي',
    allowOthersToSeeYourEmail: 'السماح للآخرين برؤية عنوان بريدك الإلكتروني',
    showActivityStatus: 'إظهار حالة النشاط',
    showWhenYouAreOnline: 'إظهار متى تكون متصل أو آخر ظهور',
    autoSaveData: 'حفظ البيانات تلقائياً',
    automaticallySaveYourSettings: 'حفظ إعداداتك وتفضيلاتك تلقائياً',
    privacySettingsNote: 'يتم حفظ إعدادات الخصوصية تلقائياً',
    profileUpdatedSuccessfully: 'تم تحديث الملف الشخصي بنجاح',
    failedToUpdateProfile: 'فشل تحديث الملف الشخصي. يرجى المحاولة مرة أخرى.',
    passwordChangedSuccessfully: 'تم تغيير كلمة المرور بنجاح',
    pleaseLoginAgain: 'يرجى تسجيل الدخول مرة أخرى بكلمة المرور الجديدة',
    failedToChangePassword: 'فشل تغيير كلمة المرور. يرجى التحقق من كلمة المرور الحالية والمحاولة مرة أخرى.',
    failedToLoadPaymentAccounts: 'فشل تحميل حسابات الدفع. يرجى المحاولة مرة أخرى.',
    accountDeletedSuccessfully: 'تم حذف الحساب بنجاح. سيتم تسجيل الخروج تلقائياً.',
    
    // Payment Accounts
    paymentAccounts: 'حسابات الدفع',
    paymentAccountsDescription: 'إدارة حسابات الدفع التي سيتم عرضها لأصحاب الأعمال لدفع الباقات',
    addAccount: 'إضافة حساب',
    noPaymentAccounts: 'لا توجد حسابات دفع',
    addFirstAccount: 'انقر على "إضافة حساب" لإنشاء أول حساب دفع',
    visible: 'ظاهر',
    hidden: 'مخفي',
    confirmDeleteAccount: 'حذف حساب الدفع',
    deleteAccount: 'حذف الحساب',
    editAccount: 'تعديل حساب الدفع',
    paymentAccountDescription: 'أضف حساب دفع سيتم عرضه لأصحاب الأعمال',
    paymentMethod: 'طريقة الدفع',
    vodafoneCash: 'فودافون كاش',
    orangeMoney: 'أورنج موني',
    etisalatCash: 'اتصالات كاش',
    weCash: 'وي كاش',
    instapay: 'إنستاباي',
    other: 'أخرى',
    accountNumber: 'رقم الحساب',
    accountName: 'اسم الحساب',
    makeVisibleToBusinessOwners: 'جعله ظاهراً لأصحاب الأعمال',
    notes: 'ملاحظات',
    accountNotesPlaceholder: 'ملاحظات إضافية حول هذا الحساب...',
    updateAccount: 'تحديث',
    accountUpdated: 'تم تحديث الحساب بنجاح',
    accountAdded: 'تم إضافة الحساب بنجاح',
    accountDeleted: 'تم حذف الحساب بنجاح',
    confirmDeleteMessage: 'هل أنت متأكد من حذف هذا الصنف؟ لا يمكن التراجع عن هذا الإجراء.',
    confirmDeleteAccountMessage: 'هل أنت متأكد من حذف حساب الدفع هذا؟ لا يمكن التراجع عن هذا الإجراء.',
    
    // Notifications & Data Settings
    notificationsAndData: 'الإشعارات والبيانات',
    inAppNotifications: 'الإشعارات داخل التطبيق',
    receiveInAppNotifications: 'تلقي الإشعارات داخل التطبيق',
    showRenewalDates: 'إظهار تواريخ التجديد',
    dataManagement: 'إدارة البيانات',
    dataManagementDescription: 'حذف حسابك وجميع البيانات المرتبطة به',
    accountManagement: 'إدارة الحساب',
    businessManagementSettings: 'إعدادات إدارة الأعمال',
    businessManagementSettingsDescription: 'إدارة الإعدادات الخاصة بأعمالك',
    orderSettings: 'إعدادات الطلبات',
    autoAcceptOrders: 'قبول الطلبات تلقائياً',
    autoAcceptOrdersDescription: 'قبول جميع الطلبات الجديدة تلقائياً بدون مراجعة',
    enableDelivery: 'تفعيل التوصيل',
    enableDeliveryDescription: 'السماح للعملاء بطلب التوصيل',
    enablePickup: 'تفعيل الاستلام',
    enablePickupDescription: 'السماح للعملاء باستلام الطلبات من الفرع',
    enableTableService: 'تفعيل الخدمة على الطاولات',
    enableTableServiceDescription: 'السماح للعملاء بطلب الطعام للطاولات',
    sendOrderNotifications: 'إشعارات الطلبات',
    sendOrderNotificationsDescription: 'تلقي إشعارات عند وصول طلبات جديدة',
    sendPaymentNotifications: 'إشعارات المدفوعات',
    sendPaymentNotificationsDescription: 'تلقي إشعارات عند استلام المدفوعات',
    sendCustomerNotifications: 'إشعارات العملاء',
    sendCustomerNotificationsDescription: 'تلقي إشعارات عند تفاعل العملاء',
    inventorySettings: 'إعدادات المخزون',
    enableInventoryTracking: 'تتبع المخزون',
    enableInventoryTrackingDescription: 'تتبع كمية المنتجات المتوفرة في المخزون',
    enableLowStockAlerts: 'تنبيهات المخزون المنخفض',
    enableLowStockAlertsDescription: 'تلقي تنبيهات عند انخفاض المخزون',
    settingsSavedSuccessfully: 'تم حفظ الإعدادات بنجاح',
    failedToSaveSettings: 'فشل حفظ الإعدادات',
    exportData: 'تصدير البيانات',
    export: 'تصدير',
    downloadYourAccountData: 'تحميل نسخة من بيانات حسابك بصيغة JSON',
    dataExportedSuccessfully: 'تم تصدير البيانات بنجاح',
    deleteAccountPermanently: 'حذف حسابك نهائياً وجميع البيانات المرتبطة به. لا يمكن التراجع عن هذا الإجراء.',
    confirmDeleteAccountMessageFull: 'هل أنت متأكد من حذف حسابك؟ سيتم حذف جميع بياناتك بما في ذلك حسابات الدفع والإعدادات وسجل النشاط بشكل دائم. لا يمكن التراجع عن هذا الإجراء.',
    accountDeleteRequestSubmitted: 'تم تقديم طلب حذف الحساب. سيتم تسجيل الخروج قريباً.',
    typeLast5Digits: 'يرجى كتابة آخر 5 أرقام من رقم هاتفك "{digits}" لتأكيد حذف حسابك:',
    incorrectPhoneDigits: 'الأرقام المدخلة غير صحيحة. يرجى كتابة آخر 5 أرقام من رقم هاتفك بالضبط كما هو موضح أعلاه.',
  },
  en: {
    // Site Info
    siteName: 'Hatli',
    siteDescription: 'Platform for menu and order management',
    
    // Common
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    cancel: 'Cancel',
    save: 'Save',
    saving: 'Saving...',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    search: 'Search',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    close: 'Close',
    more: 'More',
    month: 'month',
    moreFeatures: 'more features',
    mostPopular: 'Most Popular',
    upgrade: 'Upgrade',
    
    // Navigation
    dashboard: 'Dashboard',
    adminPanel: 'Admin Panel',
    monitorPanel: 'Monitor Panel',
    userManagement: 'User Management',
    businessManagement: 'Business Management',
    paymentManagement: 'Payment Management',
    campaignManagement: 'Advertising Campaigns Management',
    campaignManagementDescription: 'Manage and organize your advertising and marketing campaigns',
    advertisingCampaigns: 'Advertising Campaigns',
    createCampaign: 'Create Advertising Campaign',
    editCampaign: 'Edit Advertising Campaign',
    deleteCampaign: 'Delete Advertising Campaign',
    deleteCampaignDescription: 'Are you sure you want to delete this advertising campaign? This action cannot be undone.',
    campaignName: 'Advertising Campaign Name',
    campaignDescription: 'Advertising Campaign Description',
    campaignCreated: 'Advertising campaign created successfully',
    campaignUpdated: 'Advertising campaign updated successfully',
    campaignDeleted: 'Advertising campaign deleted successfully',
    noCampaigns: 'No advertising campaigns found',
    startDate: 'Start Date',
    endDate: 'End Date',
    campaignNameRequired: 'Campaign name is required',
    campaignNamePlaceholder: 'Enter campaign name',
    campaignDescriptionPlaceholder: 'Enter campaign description (optional)',
    createCampaignDescription: 'Create a new advertising campaign',
    editCampaignDescription: 'Edit campaign details',
    campaignDetails: 'Campaign Details',
    businessDetails: 'Business Details',
    campaignStatusDescription: 'Active campaigns will be visible and can receive scans',
    endDateMustBeAfterStartDate: 'End date must be after start date',
    pleaseFillRequiredFields: 'Please fill all required fields',
    statistics: 'Statistics',
    visits: 'Visits',
    last24Hours: 'Last 24 Hours',
    totalOrders: 'Total Orders',
    totalVisits: 'Total Visits',
    totalScans: 'Total Scans',
    allTime: 'All Time',
    businessPerformanceOverview: 'Performance Overview',
    ordersBreakdown: 'Orders Breakdown',
    pendingOrders: 'Pending Orders',
    awaitingProcessing: 'Awaiting processing',
    completedOrders: 'Completed Orders',
    successfullyDelivered: 'Successfully delivered',
    engagementMetrics: 'Engagement Metrics',
    uniqueVisitors: 'Unique Visitors',
    distinctUsers: 'Distinct users',
    qrCodeScans: 'QR Code Scans',
    statisticsComingSoon: 'Statistics Coming Soon',
    statisticsInfo: 'Detailed statistics will be displayed once you start receiving orders and visits. Track your business performance from here.',
    filterByDate: 'Filter by Date',
    selectDateRange: 'Select date range to view statistics',
    fromDate: 'From Date',
    toDate: 'To Date',
    selectFromDate: 'Select start date',
    selectToDate: 'Select end date',
    invalidDateRange: 'Start date must be before end date',
    filterApplied: 'Filter applied',
    filterCleared: 'Filter cleared',
    activeFilter: 'Active Filter:',
    from: 'From',
    to: 'To',
    allCampaigns: 'All Campaigns',
    activeCampaigns: 'Active Campaigns',
    inactiveCampaigns: 'Inactive Campaigns',
    download: 'Download',
    downloadQRCode: 'Download QR Code',
    qrCodeDownloaded: 'QR Code downloaded successfully',
    menuManagement: 'Menu Management',
    analytics: 'Analytics',
    businesses: 'Businesses',
    menus: 'Menus',
    orders: 'Orders',
    settings: 'Settings',
    notifications: 'Notifications',
    logout: 'Logout',
    confirmLogout: 'Confirm Logout',
    confirmLogoutMessage: 'Are you sure you want to logout? You will need to sign in again to access your account.',
    
    // Business Management
    editBusiness: 'Edit Business',
    businessName: 'Name',
    businessDescription: 'Description',
    businessAddress: 'Address',
    businessPhone: 'Phone',
    businessType: 'Type',
    slug: 'Slug',
    slugHelperText: 'URL-friendly identifier for your business (e.g., my-business-name)',
    businessLogo: 'Business Logo',
    uploadLogo: 'Upload Logo',
    invalidImageFile: 'Please select a valid image file',
    fileTooLarge: 'File size is too large. Maximum size is 2MB',
    logoUploaded: 'Logo uploaded successfully',
    selectLogoImage: 'Select an image for the logo (PNG, JPG, JPEG - Maximum 2MB)',
    currentLogo: 'Current Logo',
    logoPreview: 'New Logo Preview',
    clickToSelectImage: 'Click to select image or drag file here',
    businessColor: 'Brand Color',
    businessColorHelperText: 'Choose your brand color (used in the menu)',
    
    qrCode: 'QR Code',
    
    // Menu
    menu: 'Menu',
    categories: 'Categories',
    items: 'Items',
    menuItem: 'Menu Item',
    price: 'Price',
    available: 'Available',
    unavailable: 'Unavailable',
    addToCart: 'Add to Cart',
    
    // Cart messages
    itemNotAvailable: 'This item is not available',
    itemAddedToCart: 'Item added to cart',
    itemQuantityUpdated: 'Item quantity updated',
    itemRemovedFromCart: 'Item removed from cart',
    cartCleared: 'Cart cleared',
    shoppingCart: 'Shopping Cart',
    cartEmpty: 'Your cart is empty',
    addItemsFromMenu: 'Add some items from the menu',
    confirmOrder: 'Confirm Order',
    orderConfirmed: 'Order Confirmed!',
    thankYouContactSoon: 'Thank you, we will contact you soon',
    clearCart: 'Clear Cart',
    clearCartConfirm: 'Clear Cart?',
    clearCartConfirmMessage: 'Are you sure you want to clear all items from your cart?',
    
    // Status
    online: 'Online',
    offline: 'Offline',
    
    // Dashboard
    welcomeMessage: 'Welcome to the Hatli',
    totalBusinesses: 'Businesses',
    todayOrders: 'Today\'s Orders',
    menuItems: 'Menus',
    totalRevenue: 'Total Revenue',
    quickActions: 'Quick Actions',
    quickActionsDescription: 'Start managing your businesses',
    manageBusinesses: 'Manage Businesses',
    createNewBusiness: 'Create New Business',
    manageMenus: 'Manage Menus',
    noBusinessesYet: 'No businesses yet',
    createBusiness: 'Create Business',
    businessCreatedSuccessfully: 'Business created successfully',
    businessUpdated: 'Business updated successfully',
    businessNotFound: 'Business not found',
    updateBusinessLogo: 'Update Business Logo',
    basicInformation: 'Basic Information',
    contactInformation: 'Contact Information',
    taxFee: 'Tax Fee',
    taxFeeManagement: 'Tax Fee Management',
    taxFeeDescription: 'Manage the tax rate applied to orders',
    taxFeeHelperText: 'Tax rate as a percentage (e.g., 5 means 5%)',
    taxFeeUpdated: 'Tax rate updated successfully',
    example: 'Example Calculation',
    forOrderOf: 'For an order of',
    taxWillBe: 'tax will be',
    totalAmount: 'Total amount',
    currency: 'EGP',
    invalidValue: 'Invalid value. Must be between 0 and 100',
    manage: 'Manage',
    viewAll: 'View All',
    soon: 'Soon',
    
    // Business Management Page
    businessManagementTitle: 'Business Management',
    businessManagementDescription: 'Manage your businesses',
    addNewBusiness: 'Add New Business',
    noBusinesses: 'No Businesses',
    noBusinessesDescription: 'Start by creating your first business to manage menus and orders',
    noDescription: 'No description',
    active: 'Active',
    inactive: 'Inactive',
    confirmDelete: 'Are you sure you want to delete',
    deleteBusiness: 'Delete Business',
    deleteBusinessMessage: 'Are you sure you want to permanently delete the business "{name}"?',
    deleteBusinessDetails: 'All data associated with this business will be permanently deleted and this action cannot be undone, including:\n• All menus and products\n• All advertising campaigns\n• All orders and records\n• All statistics and analytics',
    businessDeleted: 'Business deleted successfully',
    confirmDeleteSlug: 'To confirm deletion, please enter the business slug:',
    slugMismatch: 'Incorrect slug. Please enter the correct slug to confirm.',
    noResults: 'No Results',
    noResultsDescription: 'No businesses found matching the search',
    
    backToBusinesses: 'Back to Businesses',
    acceptingOrders: 'Accepting Orders',
    notAcceptingOrders: 'Not Accepting Orders',
    showQRCode: 'Show QR Code',
    invalidBusinessId: 'Invalid business ID',
    
    addressRequired: 'Address is required',
    addressTooLong: 'Address is too long (maximum 200 characters)',
    phoneRequired: 'Phone number is required',
    phoneTooLong: 'Phone number is too long (maximum 20 digits)',
    addressPlaceholder: 'Complete address',
    phonePlaceholder: '01xxxxxxxxx',
    qrNote: 'A unique QR code will be automatically generated after creation.',
    note: 'Note:',
    
    // Validation Messages
    validationError: 'Validation Error',
    fieldRequired: 'This field is required',
    fieldTooLong: 'Value is too long',
    fieldTooShort: 'Value is too short',
    invalidFormat: 'Invalid format',
    invalidPhoneFormat: 'Invalid phone number format. Must start with 01 and contain 11 digits',
    duplicateValue: 'This value already exists',
    serverError: 'Server error',
    
    businessInformation: 'Business Information',
    timestamps: 'Timestamps',
    createdAt: 'Created At',
    lastUpdated: 'Last Updated',
    address: 'Address',
    phoneNumber: 'Phone Number',
    qrCodeGenerated: 'QR Code Generated',
    businessStatus: 'Business Status',
    toggleOrders: 'Toggle Orders',
    startAcceptingOrders: 'Start Accepting Orders',
    stopAcceptingOrders: 'Stop Accepting Orders',
    viewQRCode: 'View QR Code',
    viewPublicMenu: 'View Public Menu',
    invalidParameters: 'Invalid parameters',
    viewDetails: 'View Details',
    
    // Menu Management Errors
    categoryDeleteError: 'Failed to delete category',
    categoryDeleteNotFound: 'Category not found or has already been deleted',
    categoryDeleteUnauthorized: 'You do not have permission to delete this category',
    categoryDeleteNetworkError: 'A network error occurred. Please try again',
    categoryDeletedSuccessfully: 'Category deleted successfully',
    itemDeleteError: 'Failed to delete item',
    itemDeleteNotFound: 'Item not found or has already been deleted',
    itemDeleteUnauthorized: 'You do not have permission to delete this item',
    itemDeleteNetworkError: 'A network error occurred. Please try again',
    itemDeletedSuccessfully: 'Item deleted successfully',
    
    // Menu Management Page
    menuManagementTitle: 'Menu Items and Prices Management',
    selectBusiness: 'Select Business',
    noBusinessesFound: 'No Businesses',
    noBusinessesFoundDescription: 'You must create a business first to manage menus',
    category: 'Category',
    categoryCount: 'Category',
    addNewCategory: 'Add New Category',
    editCategory: 'Edit Category',
    editItem: 'Edit Item',
    noCategories: 'No Categories',
    createNewCategory: 'Create New Category',
    updating: 'Updating...',
    itemCount: 'Item',
    item: 'Item',
    allItems: 'All Items',
    addNewItem: 'Add New Item',
    createCategoryFirst: 'You must create a category first to add items',
    noItemsInCategory: 'No items in this category',
    noItems: 'No Items',
    menuItemsTitle: 'Menu Items',
    menuItemsDescription: 'Manage menu items and their prices',
    menuCategoriesTitle: 'Menu Categories',
    menuCategoriesDescription: 'Manage menu categories and their order',
    searchItemPlaceholder: 'Search for item by name or description...',
    noSearchResults: 'No search results',
    tryDifferentSearch: 'Try searching with different words or select another category',
    startAddingItems: 'Start adding new items to the menu',
    mustCreateCategoryFirst: 'You must create at least one category before adding items',
    refreshPage: 'Refresh Page',
    uploadImage: 'Upload Image',
    confirmDeleteImage: 'Are you sure you want to delete the image?',
    enable: 'Enable',
    disable: 'Disable',
    restaurantMenu: 'Restaurant Menu',
    deleteItemConfirm: 'Are you sure you want to delete the item',
    deleteCategoryConfirm: 'Are you sure you want to delete the category',
    cannotUndo: 'This action cannot be undone',
    deleteCategory: 'Delete Category',
    deleteItem: 'Delete Item',
    selectBusinessToManageMenu: 'Select a business from the list above to manage menu',
    image: 'Image',
    name: 'Name',
    description: 'Description',
    status: 'Status',
    actions: 'Actions',
  
    menuAccess: 'Menu Access',
    shareMenuWithCustomers: 'Share menu with customers',
    qrCodePreview: 'QR Code Preview',
    scanToViewMenu: 'Scan to view menu',
    menuLink: 'Menu Link',
    copy: 'Copy',
    copied: 'Copied',
    failedToCopy: 'Failed to copy',
    linkCopied: 'Link copied successfully',
    copyFailed: 'Failed to copy link',
    viewFullQRCode: 'View Full QR Code',
    shareMenu: 'Share Menu',
    quickStats: 'Quick Stats',
    menuStatus: 'Menu Status',
    publicAccess: 'Public Access',
    enabled: 'Enabled',
    
    // Homepage
    homepagePlatformDescription: 'Platform for managing menus and orders',
    homepageTitle: 'Transform Your',
    homepageTitleSecondary: 'Menu Into a Smart Digital Platform',
    homepageDescription: 'Create interactive digital menus with QR codes and integrated ordering system via WhatsApp. Perfect for restaurants, cafes, and shops.',
    homepageStartFree: 'Start Free',
    homepageSignIn: 'Sign In',
    homepageStatsFree: 'Free',
    homepageStatsMin: 'Min',
    homepageStatsSupport: 'Support',
    homepageFeaturesTitle: 'What We Offer',
    homepageFeaturesDescription: 'Steps to easily manage your menus and orders',
    homepageFeatureQRCode: 'QR Code',
    homepageFeatureQRCodeDesc: 'Professional QR codes to display your menu. Simple scan and instant access to the menu',
    homepageFeatureWhatsApp: 'WhatsApp Integration',
    homepageFeatureWhatsAppDesc: 'Receive your orders easily and send order status to customers via WhatsApp',
    homepageFeatureAnalytics: 'Analytics & Tracking',
    homepageFeatureAnalyticsDesc: 'Track campaign performance, customer behavior, and sales with detailed analytics.',
    homepageFeatureQuick: 'Quick & Easy',
    homepageFeatureQuickDesc: 'Set up and update your menu in minutes with zero complexity.',
    homepageFeatureResponsive: 'Fully Responsive',
    homepageFeatureResponsiveDesc: 'Works perfectly on all devices and smartphones.',
    homepageFeatureSales: 'Boost Sales',
    homepageFeatureSalesDesc: 'Enhance customer experience and increase order rates and revenue.',
    homepageBenefitsTitle: 'Why Hatli?',
    homepageBenefitsDescription: 'The perfect solution for managing digital menus professionally and easily',
    homepageBenefit1: 'No need for traditional printed menus',
    homepageBenefit2: 'Instant updates for prices and items',
    homepageBenefit3: 'Business management',
    homepageBenefit4: 'Marketing campaign tracking',
    homepageBenefit5: 'Multi-language support',
    homepageBenefit6: 'Dedicated support team ready to help you anytime',
    homepageStartFreeNow: 'Start Free Now',
    homepageHowToStartTitle: 'How to Get Started?',
    homepageHowToStartDescription: 'Three simple steps to start using Hatli',
    homepageStep1Title: 'Sign Up',
    homepageStep1Description: 'Create your free account in minutes',
    homepageStep2Title: 'Add Your Menu',
    homepageStep2Description: 'Start by adding products and categorizing them',
    homepageStep3Title: 'Share QR Code',
    homepageStep3Description: 'Get your QR code and start receiving orders',
    homepageCTATitle: 'Ready to Get Started?',
    homepageCTADescription: 'Start free and enhance your customer experience',
    homepageCTACreateAccount: 'Create Free Account',
    homepageFooterQuickLinks: 'Quick Links',
    homepageFooterContact: 'Contact Us',
    homepageFooterRegister: 'Register',
    homepageFooterAllRightsReserved: 'All rights reserved',
    homepageContactFacebook: 'Contact us on Facebook',
    homepageContactInstagram: 'Contact us on Instagram',
    homepageContactWhatsApp: 'Contact us on WhatsApp',
    homepageClose: 'Close',
    homepageZoomIn: 'Zoom In',
    homepageZoomOut: 'Zoom Out',
    homepagePressEscToClose: 'Press ESC to close',
    homepageZoomedImage: 'Zoomed image',
    homepageQRCard: 'QR Card',
    homepageDigitalMenu: 'Digital Menu',
    homepageWhyHatli: 'Why Hatli',
    
    // Login Page
    loginWelcomeBackTo: 'Welcome to',
    loginFeatureMenuManagement: 'Easy menu management and updates',
    loginFeatureOrderTracking: 'Real-time order tracking and analytics',
    loginFeatureCustomerExperience: 'Seamless customer experience',
    loginSignInToAccount: 'Sign In',
    loginDontHaveAccount: "Don't have an account?",
    loginSignUpForFree: 'Sign up for free',
    loginAccountType: 'Account Type',
    loginBusinessOwner: 'Business Owner',
    loginAdministrator: 'Administrator',
    loginPhoneNumber: 'Phone Number',
    loginPassword: 'Password',
    loginPasswordPlaceholder: 'Enter your password',
    loginSignIn: 'Sign in',
    loginSigningIn: 'Signing in...',
    loginQuickTestLogin: 'Quick Test Login',
    loginBusinessOwners: 'Business Owners',
    loginAdministrators: 'Administrators',
    loginTermsAgreement: 'By signing in, you agree to our Terms of Service and Privacy Policy',
    loginSuccess: 'Login successful!',
    loginInvalidCredentials: 'Invalid credentials. Please check your phone number and password.',
    loginFailed: 'Login failed. Please try again.',
    loginQuickLoginSuccess: 'Logged in successfully',
    loginQuickLoginFailed: 'Quick login failed. Please try again.',
    loginValidationPhoneFormat: 'Invalid phone number format',
    loginValidationPasswordRequired: 'Password is required',
    loginLoggedInAsAdmin: 'Admin',
    loginLoggedInAsBusinessOwner: 'Business Owner',
    loginRememberMe: 'Remember me',
    loginForgotPassword: 'Forgot password?',
    
    // Registration Validation
    registerValidationNameMin: 'Name must be at least 2 characters',
    registerValidationEmailInvalid: 'Invalid email format',
    registerValidationPasswordMin: 'Password must be at least 8 characters',
    registerValidationPasswordMismatch: 'Passwords do not match',
    
    
    // Business Validation
    businessValidationNameMin: 'Business name must be at least 2 characters',
    businessValidationNameMax: 'Business name is too long',
    businessValidationDescriptionMax: 'Description is too long',
    businessValidationAddressMin: 'Address must be at least 5 characters',
    businessValidationAddressMax: 'Address is too long',
    businessValidationTypeRequired: 'Business type is required',
    
    
    // Category Validation
    categoryValidationNameMin: 'Category name must be at least 2 characters',
    categoryValidationNameMax: 'Category name is too long',
    categoryValidationDescriptionMax: 'Category description is too long',
    categoryValidationNameRequired: 'Category name is required',
    categoryValidationSortOrderPositive: 'Category order must be a positive number',
    categoryNameLabel: 'Category Name',
    categorySortOrderLabel: 'Category Order',
    categorySortOrderHelper: 'Lower number appears first in menu',
    categoryActiveLabel: 'Active category (visible to customers)',
    categorySelectPlaceholder: 'Select Category',
    categoryRequired: 'Category selection is required',
    
    // Item Validation
    itemValidationNameMin: 'Item name must be at least 2 characters',
    itemValidationNameMax: 'Item name is too long',
    itemValidationDescriptionMax: 'Item description is too long',
    itemValidationPriceMin: 'Price must be at least 0.01',
    itemValidationPriceMax: 'Price is too high',
    itemValidationCategoryRequired: 'Category selection is required',
    itemValidationNameRequired: 'Item name is required',
    itemValidationPriceRequired: 'Price is required',
    itemValidationPriceInvalid: 'Price must be a number',
    itemValidationPriceMinValue: 'Price must be greater than zero',
    itemValidationSortOrderPositive: 'Item order must be a positive number',
    itemNameLabel: 'Item Name',
    itemDescriptionLabel: 'Description',
    itemDescriptionOptional: 'Optional',
    itemPriceLabel: 'Price',
    itemSortOrderLabel: 'Item Order',
    itemSortOrderHelper: 'Lower number appears first in menu',
    itemAvailableLabel: 'Available for order',
    itemDescriptionPlaceholder: 'Item description and ingredients...',
    itemNamePlaceholder: 'Example: Beef burger, Green salad',
    itemCategoryPlaceholder: 'Select Category',
    
    // Customer Info Modal
    customerInformation: 'Customer Information',
    enterDetailsToCompleteOrder: 'Enter your details to complete the order',
    customerName: 'Name',
    customerNamePlaceholder: 'Enter your name',
    customerPhone: 'WhatsApp Number',
    customerPhonePlaceholder: '05xxxxxxxx',
    addressNotRequired: 'Address not required',
    enterDeliveryAddress: 'Enter delivery address',
    pleaseEnterName: 'Please enter your name',
    pleaseEnterWhatsApp: 'Please enter your WhatsApp number',
    pleaseEnterDeliveryAddress: 'Please enter delivery address',
    restaurantWhatsAppNotAvailable: 'Restaurant WhatsApp number is not available',
    sending: 'Sending...',
    sendWhatsApp: 'Send WhatsApp',
    customerData: 'Customer Data',
    enjoyExperience: 'We hope you enjoy your experience!',
    thanksForChoosing: 'Thank you for choosing',
    forMoreOrders: 'For more orders:',
    
    // Password Validation
    changePasswordValidationCurrentRequired: 'Current password is required',
    passwordRequired: 'Password is required',
    
    // Access Denied
    accessDeniedTitle: 'Access Denied',
    accessDeniedDescription: 'Sorry, you do not have permission to access this page.',
    accessDeniedContactAdmin: 'Please contact an administrator if you believe this is an error.',
    accessDeniedGoToDashboard: 'Go to Dashboard',
    accessDeniedHomePage: 'Home Page',
    accessDeniedRequestPermission: 'If you need access to this page, please request the appropriate permissions from an administrator.',
    
    // 404 Not Found Page
    notFoundTitle: '404',
    notFoundDescription: 'The page you are looking for does not exist.',
    notFoundMessage: 'The page may have been deleted, moved, or the link may be incorrect.',
    notFoundGoToHome: 'Home Page',
    notFoundGoBack: 'Go Back',
    
    // User Roles
    userRoleSystemAdmin: 'System Admin',
    userRoleMonitor: 'Monitor',
    userRoleBusinessOwner: 'Business Owner',
    userRoleEmployee: 'Employee',
    userRoleClient: 'Client',
    userRoleCashier: 'Cashier',
    
    // User Management
    userManagementDescription: 'Manage users in your business',
    addUser: 'Add User',
    editUser: 'Edit User',
    deleteUser: 'Delete User',
    searchUsers: 'Search users by name, phone, email, or role...',
    noUsers: 'No users found',
    noUsersDescription: 'Get started by adding your first user',
    userCreated: 'User created successfully',
    userUpdated: 'User updated successfully',
    userDeleted: 'User deleted successfully',
    failedToGetUsers: 'Failed to load users',
    failedToCreateUser: 'Failed to create user',
    failedToUpdateUser: 'Failed to update user',
    failedToDeleteUser: 'Failed to delete user',
    failedToSaveUser: 'Failed to save user',
    nameAndPhoneRequired: 'Name and phone number are required',
    namePhoneAndEmailRequired: 'Name, phone number, and email are required',
    nameRequired: 'Name is required',
    phoneNumberRequired: 'Phone number is required',
    emailRequired: 'Email is required',
    enterName: 'Enter name',
    enterPhoneNumber: 'Enter phone number',
    enterEmail: 'Enter email (optional)',
    enterPassword: 'Enter password',
    enterNewPassword: 'Enter new password (optional)',
    confirmDeleteUser: 'Are you sure you want to delete',
    thisActionCannotBeUndone: 'This action cannot be undone and will permanently delete the user and all related data.',
    leaveEmptyToKeepCurrent: 'Leave empty to keep current',
    user: 'User',
    users: 'Users',
    contact: 'Contact',
    password: 'Password',
    userActiveDescription: 'User is active and can log in and use the system',
    userInactiveDescription: 'User is inactive and will not be able to log in',
    
    
    // Admin Permissions
    adminPermissionManageUsers: 'Manage Users',
    adminPermissionManageBusinesses: 'Manage Businesses',
    adminPermissionManagePayments: 'Manage Payments',
    adminPermissionViewAnalytics: 'View Analytics',
    adminPermissionSystemAdmin: 'System Admin',
    
    // Analytics Event Types
    analyticsEventTypeVisit: 'Visit',
    analyticsEventTypeOrder: 'Order',
    analyticsEventTypeScan: 'Scan',
    
    // Business Types
    businessTypeRestaurant: 'Restaurant',
    businessTypeCafe: 'Cafe',
    businessTypeShop: 'Shop',
    businessTypeOther: 'Other',
    
    // Order Status
    orderStatusPending: 'Pending',
    orderStatusPreparing: 'Preparing',
    orderStatusReady: 'Ready',
    orderStatusCompleted: 'Completed',
    orderStatusCancelled: 'Cancelled',
    
    // Order Types
    orderTypePickup: 'Pickup',
    orderTypeDelivery: 'Delivery',
    orderTypeTable: 'Table',
    
    // Settings Page
    adminSettingsDescription: 'Manage your admin account settings and system preferences',
    monitorSettingsDescription: 'Manage your monitor account settings and preferences',
    businessSettingsDescription: 'Manage your business owner or employee account settings',
    profileSettings: 'Profile',
    profileSettingsDescription: 'Update your personal information',
    securitySettings: 'Security',
    securitySettingsDescription: 'Change your password to keep your account secure',
    systemSettings: 'System Settings',
    systemSettingsDescription: 'Configure system-wide settings and preferences',
    systemSettingsComingSoon: 'System settings will be available soon',
    notificationSettings: 'Notifications',
    notificationSettingsDescription: 'Manage how you receive notifications',
    preferences: 'Preferences',
    preferencesDescription: 'Customize your application preferences',
    accountInformation: 'Account Information',
    accountInformationDescription: 'View your account details and permissions',
    fullName: 'Full Name',
    email: 'Email',
    phoneNumberCannotBeChanged: 'Phone number cannot be changed',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm New Password',
    changePassword: 'Change Password',
    passwordMinLength: 'Password must be at least 8 characters',
    allFieldsRequired: 'All fields are required',
    passwordsDoNotMatch: 'Passwords do not match',
    passwordMustBeAtLeast8Characters: 'Password must be at least 8 characters',
    emailNotifications: 'Email Notifications',
    receiveEmailNotifications: 'Receive notifications via email',
    notificationSettingsNote: 'Notification preferences are saved automatically',
    language: 'Language',
    selectPreferredLanguage: 'Select your preferred language',
    preferencesNote: 'Preferences are saved in your browser',
    arabic: 'Arabic',
    english: 'English',
    role: 'Role',
    monitor: 'Monitor',
    accountStatus: 'Account Status',
    memberSince: 'Member Since',
    
    // Privacy & Data Settings
    privacyAndData: 'Privacy & Data',
    privacyAndDataDescription: 'Manage your privacy settings and data preferences',
    showEmailInProfile: 'Show Email in Profile',
    allowOthersToSeeYourEmail: 'Allow others to see your email address',
    showActivityStatus: 'Show Activity Status',
    showWhenYouAreOnline: 'Show when you are online or last seen',
    autoSaveData: 'Auto-save Data',
    automaticallySaveYourSettings: 'Automatically save your settings and preferences',
    privacySettingsNote: 'Privacy settings are saved automatically',
    profileUpdatedSuccessfully: 'Profile updated successfully',
    failedToUpdateProfile: 'Failed to update profile. Please try again.',
    passwordChangedSuccessfully: 'Password changed successfully',
    pleaseLoginAgain: 'Please login again with your new password',
    failedToChangePassword: 'Failed to change password. Please verify your current password and try again.',
    failedToLoadPaymentAccounts: 'Failed to load payment accounts. Please try again.',
    accountDeletedSuccessfully: 'Account deleted successfully. You will be logged out automatically.',
    
    // Payment Accounts
    paymentAccounts: 'Payment Accounts',
    paymentAccountsDescription: 'Manage your payment accounts that will be displayed to business owners for payments',
    addAccount: 'Add Account',
    noPaymentAccounts: 'No payment accounts found',
    addFirstAccount: 'Click "Add Account" to create your first payment account',
    visible: 'Visible',
    hidden: 'Hidden',
    confirmDeleteAccount: 'Delete Payment Account',
    deleteAccount: 'Delete Account',
    editAccount: 'Edit Payment Account',
    paymentAccountDescription: 'Add a payment account that will be visible to business owners',
    paymentMethod: 'Payment Method',
    vodafoneCash: 'Vodafone Cash',
    orangeMoney: 'Orange Money',
    etisalatCash: 'Etisalat Cash',
    weCash: 'We Cash',
    instapay: 'Instapay',
    other: 'Other',
    accountNumber: 'Account Number',
    accountName: 'Account Name',
    makeVisibleToBusinessOwners: 'Make visible to business owners',
    notes: 'Notes',
    accountNotesPlaceholder: 'Additional notes about this account...',
    updateAccount: 'Update',
    accountUpdated: 'Account updated successfully',
    accountAdded: 'Account added successfully',
    accountDeleted: 'Account deleted successfully',
    confirmDeleteMessage: 'Are you sure you want to delete this item? This action cannot be undone.',
    confirmDeleteAccountMessage: 'Are you sure you want to delete this payment account? This action cannot be undone.',
    
    // Notifications & Data Settings
    notificationsAndData: 'Notifications & Data',
    inAppNotifications: 'In-App Notifications',
    receiveInAppNotifications: 'Receive notifications within the application',
    showRenewalDates: 'Show Renewal Dates',
    dataManagement: 'Data Management',
    dataManagementDescription: 'Delete your account and all associated data',
    accountManagement: 'Account Management',
    businessManagementSettings: 'Business Management Settings',
    businessManagementSettingsDescription: 'Manage your business settings',
    orderSettings: 'Order Settings',
    autoAcceptOrders: 'Auto Accept Orders',
    autoAcceptOrdersDescription: 'Automatically accept all new orders without review',
    enableDelivery: 'Enable Delivery',
    enableDeliveryDescription: 'Allow customers to request delivery',
    enablePickup: 'Enable Pickup',
    enablePickupDescription: 'Allow customers to pick up orders',
    enableTableService: 'Enable Table Service',
    enableTableServiceDescription: 'Allow customers to order food for tables',
    sendOrderNotifications: 'Order Notifications',
    sendOrderNotificationsDescription: 'Receive notifications when new orders arrive',
    sendPaymentNotifications: 'Payment Notifications',
    sendPaymentNotificationsDescription: 'Receive notifications when payments are received',
    sendCustomerNotifications: 'Customer Notifications',
    sendCustomerNotificationsDescription: 'Receive notifications when customers interact',
    inventorySettings: 'Inventory Settings',
    enableInventoryTracking: 'Inventory Tracking',
    enableInventoryTrackingDescription: 'Track the quantity of products available in inventory',
    enableLowStockAlerts: 'Low Stock Alerts',
    enableLowStockAlertsDescription: 'Receive alerts when inventory is low',
    settingsSavedSuccessfully: 'Settings saved successfully',
    failedToSaveSettings: 'Failed to save settings',
    exportData: 'Export Data',
    export: 'Export',
    downloadYourAccountData: 'Download a copy of your account data in JSON format',
    dataExportedSuccessfully: 'Data exported successfully',
    deleteAccountPermanently: 'Permanently delete your account and all associated data. This action cannot be undone.',
    confirmDeleteAccountMessageFull: 'Are you sure you want to delete your account? This will permanently delete all your data including payment accounts, settings, and activity history. This action cannot be undone.',
    accountDeleteRequestSubmitted: 'Account deletion request submitted. You will be logged out shortly.',
    typeLast5Digits: 'Please type the last 5 digits of your phone number "{digits}" to confirm account deletion:',
    incorrectPhoneDigits: 'Incorrect digits. Please type the last 5 digits of your phone number exactly as shown above.',
  }
}

class I18nManager {
  private currentLanguage: Language = 'ar'
  private listeners: Array<(lang: Language) => void> = []

  constructor() {
    // Get language from localStorage or default to Arabic
    const savedLang = localStorage.getItem('language') as Language
    if (savedLang && (savedLang === 'ar' || savedLang === 'en')) {
      this.currentLanguage = savedLang
    }
    this.updateDocumentDirection()
  }

  getCurrentLanguage(): Language {
    return this.currentLanguage
  }

  setLanguage(lang: Language) {
    this.currentLanguage = lang
    localStorage.setItem('language', lang)
    this.updateDocumentDirection()
    this.notifyListeners()
  }

  toggleLanguage() {
    const newLang = this.currentLanguage === 'ar' ? 'en' : 'ar'
    this.setLanguage(newLang)
  }

  translate(key: keyof TranslationKeys): string {
    return translations[this.currentLanguage][key] || key
  }

  t = this.translate.bind(this)

  isRTL(): boolean {
    return this.currentLanguage === 'ar'
  }

  getDirection(): 'rtl' | 'ltr' {
    return this.isRTL() ? 'rtl' : 'ltr'
  }

  getFontClass(): string {
    return this.currentLanguage === 'ar' ? 'font-arabic' : 'font-english'
  }

  private updateDocumentDirection() {
    document.documentElement.dir = this.getDirection()
    document.documentElement.lang = this.currentLanguage
    
    // Update body class for font
    document.body.className = document.body.className
      .replace(/font-(arabic|english)/, '')
      .concat(` ${this.getFontClass()}`)
  }

  private notifyListeners() {
    this.listeners.forEach(listener => listener(this.currentLanguage))
  }

  subscribe(listener: (lang: Language) => void) {
    this.listeners.push(listener)
    return () => {
      this.listeners = this.listeners.filter(l => l !== listener)
    }
  }
}

export const i18n = new I18nManager()
export default i18n

// Helper function to get translated user role label
// Accepts string role value (e.g., 'system_admin', 'business_owner')
export function getUserRoleLabel(role: string): string {
  const roleMap: Record<string, keyof TranslationKeys> = {
    'system_admin': 'userRoleSystemAdmin',
    'monitor': 'userRoleMonitor',
    'business_owner': 'userRoleBusinessOwner',
    'business_employee': 'userRoleEmployee',
    'client': 'userRoleClient',
    'business_cashier': 'userRoleCashier',
  }
  
  const translationKey = roleMap[role] || 'userRoleClient'
  return i18n.translate(translationKey)
}

// Helper function to get translated admin permission label
export function getAdminPermissionLabel(permission: string): string {
  const permissionMap: Record<string, keyof TranslationKeys> = {
    'manage_users': 'adminPermissionManageUsers',
    'manage_businesses': 'adminPermissionManageBusinesses',
    'manage_payments': 'adminPermissionManagePayments',
    'view_analytics': 'adminPermissionViewAnalytics',
    'system_admin': 'adminPermissionSystemAdmin',
  }
  
  const translationKey = permissionMap[permission] || permission
  return i18n.translate(translationKey as keyof TranslationKeys) || permission
}

// Helper function to get translated analytics event type label
export function getAnalyticsEventTypeLabel(eventType: string): string {
  const eventTypeMap: Record<string, keyof TranslationKeys> = {
    'visit': 'analyticsEventTypeVisit',
    'order': 'analyticsEventTypeOrder',
    'scan': 'analyticsEventTypeScan',
  }
  
  const translationKey = eventTypeMap[eventType] || eventType
  return i18n.translate(translationKey as keyof TranslationKeys) || eventType
}

// Helper function to get translated business type label
export function getBusinessTypeLabel(businessType: string): string {
  const businessTypeMap: Record<string, keyof TranslationKeys> = {
    'restaurant': 'businessTypeRestaurant',
    'cafe': 'businessTypeCafe',
    'shop': 'businessTypeShop',
    'other': 'businessTypeOther',
  }
  
  const translationKey = businessTypeMap[businessType] || 'businessTypeOther'
  return i18n.translate(translationKey)
}

// Helper function to get translated order status label
export function getOrderStatusLabel(status: string): string {
  const statusMap: Record<string, keyof TranslationKeys> = {
    'pending': 'orderStatusPending',
    'preparing': 'orderStatusPreparing',
    'ready': 'orderStatusReady',
    'completed': 'orderStatusCompleted',
    'cancelled': 'orderStatusCancelled',
  }
  
  const translationKey = statusMap[status] || 'orderStatusPending'
  return i18n.translate(translationKey)
}

// Helper function to get translated order type label
export function getOrderTypeLabel(orderType: string): string {
  const orderTypeMap: Record<string, keyof TranslationKeys> = {
    'pickup': 'orderTypePickup',
    'delivery': 'orderTypeDelivery',
    'table': 'orderTypeTable',
  }
  
  const translationKey = orderTypeMap[orderType] || 'orderTypePickup'
  return i18n.translate(translationKey)
}